import { Action, createReducer, on } from "@ngrx/store";
import { 
    getNewEnquiryIdSuccess, 
    getQuoteDetails, 
    getQuoteDetailsSuccess, 
    savePersonalDetails, 
    saveContactDetails, 
    saveQuoteDetails, 
    saveQuoteDetailsSuccess, 
    setEnquiryId, 
    setLoadingSpinner, 
    updateQuoteDetails, 
    updateQuoteDetailsSuccess, 
    saveInvestmentDetails, 
    selectPremium, 
    selectPremiumSuccess
} from "./shared.action";
import { initialState, SharedState } from "./shared.state";

const _sharedReducer = createReducer(initialState,

    on(setLoadingSpinner, (state, action) => {
        return {
            ...state,
            loading: action.status
        }
    }),
    on(getNewEnquiryIdSuccess, (state, action) => {
        const enquiry_id: string = action.enquiry_id;
        return {
            ...state,
            enquiry_id: enquiry_id
        }
    }),
    on(setEnquiryId, (state, action) => {
        const enquiry_id: string = action.enquiry_id;
        return {
            ...state,
            enquiry_id: enquiry_id
        }
    }),
    on(saveContactDetails, (state, action) => {
        const contactDetails = { ...action.contactDetails };
        return {
            ...state,
            quote_data: {
                ...state.quote_data,
                contact_details: contactDetails
            }
        }
    }),
    on(savePersonalDetails, (state, action) => {
        const personalDetails = { ...action.personalDetails };
        return {
            ...state,
            quote_data: {
                ...state.quote_data,
                personal_details: personalDetails
            }
        }
    }),
    on(saveInvestmentDetails, (state, action) => {
        const investmentDetails = { ...action.investmentDetails };
        return {
            ...state,
            quote_data: {
                ...state.quote_data,
                investment_details: investmentDetails
            }
        }
    }),
    on(getQuoteDetails, (state, action) => {
        return {
            ...state,
            all_api_response_status: {
                ...state.all_api_response_status,
                get_pre_quote_data: false
            }
        }
    }),
    on(getQuoteDetailsSuccess, (state, action) => {
        return {
            ...state,
            all_api_response_status: {
                ...state.all_api_response_status,
                get_pre_quote_data: true
            },
            quote_data: action.quote_details
        }
    }),
    on(saveQuoteDetails, (state) => {
        return {
            ...state,
            all_api_response_status: {
                ...state.all_api_response_status,
                save_pre_quote_data: false
            }
        }
    }),
    on(saveQuoteDetailsSuccess, (state, action) => {
        const enquiry_id: string = action.enquiry_id;
        return {
            ...state,
            all_api_response_status: {
                ...state.all_api_response_status,
                save_pre_quote_data: true
            },
            enquiry_id: enquiry_id
        }
    }),
    on(updateQuoteDetails, (state) => {
        return {
            ...state,
            all_api_response_status: {
                ...state.all_api_response_status,
                update_pre_quote_data: false
            }
        }
    }),
    on(updateQuoteDetailsSuccess, (state, action) => {
        const enquiry_id: string = action.enquiry_id;
        return {
            ...state,
            all_api_response_status: {
                ...state.all_api_response_status,
                update_pre_quote_data: true
            },
            enquiry_id: enquiry_id
        }
    }),
    on(selectPremium, (state, action) => {
        return {
            ...state,
            all_api_response_status: {
                ...state.all_api_response_status,
                select_premium: false
            }
        }
    }),
    on(selectPremiumSuccess, (state, action) => {
        return {
            ...state,
            all_api_response_status: {
                ...state.all_api_response_status,
                select_premium: true
            }
        }
    })
);

export function sharedReducer(state: SharedState | undefined, action: Action) {
    return _sharedReducer(state, action);
}